import { cleaning } from 'config';
import useData from 'hooks/useData';
import Layout from 'components/general/Layout';
import { formatDate, isCurrent } from 'utils';
import NoData from 'components/general/NoData';

export default function Hospitality(): JSX.Element {
    const { data: allData } = useData(cleaning);
    const rawData = allData as any;

    const data = rawData?.map((item: any) => ({
        fecha: item.c[0]?.f ||'',
        grupo: item.c[1]?.v ||'',
        hospitality: item.c[2]?.v ||'',
    })) || [];

    const currentData = data.filter((item: any) => {
        if (!isCurrent(item.fecha)) return false;
        const day = new Date(item.fecha.replaceAll('-', '/')).getDay();
        return day === 0 || day === 6;
    });

    return (
        <Layout title="Hospitalidad">
            {!currentData.length && (
                <NoData />
            )}
            {currentData.map((item: any, index: number) => (
                <div className="block-container" key={index}>
                    <div className="date-cleaning">{formatDate(item.fecha)}</div>
                    <div className="group">{item.hospitality}</div>
                </div>
            ))}
        </Layout>
    );
}
